import { authApi } from './axios'

export const authAPI = {
  // Send signup OTP (before registration)
  sendSignupOtp: async (email) => {
    const response = await authApi.post('/send-signup-otp', null, {
      params: { email }
    })
    return response.data
  },

  verifySignupOtp: async (email, otp) => {
    const response = await authApi.post('/verify-signup-otp', null, {
      params: { email, otp }
    })
    return response.data
  },

  // Register new user
  register: async (userData) => {
    const response = await authApi.post('/register', userData)
    return response.data
  },

  // Login user
  login: async (credentials) => {
    const response = await authApi.post('/login', credentials)
    return response.data
  },

  // Refresh token
  refreshToken: async (refreshToken) => {
    const response = await authApi.post('/refresh', { refreshToken })
    return response.data
  },

  // Logout user
  logout: async (token) => {
    const response = await authApi.post('/logout', {}, {
      headers: { Authorization: `Bearer ${token}` }
    })
    return response.data
  },

  // Get current user
  getCurrentUser: async () => {
    const response = await authApi.get('/me')
    return response.data
  },

  // Forgot password
  forgotPassword: async (email) => {
    const response = await authApi.post('/forgot-password', null, {
      params: { email }
    })
    return response.data
  },

  // Reset password
  resetPassword: async (email, otp, newPassword) => {
    const response = await authApi.post('/reset-password', null, {
      params: { email, otp, newPassword }
    })
    return response.data
  },

  // Verify email
  verifyEmail: async (token) => {
    const response = await authApi.post('/verify-email', null, {
      params: { token }
    })
    return response.data
  },

  // Validate token
  validateToken: async (token) => {
    const response = await authApi.get('/validate-token', {
      params: { token }
    })
    return response.data
  },

  socialLogin: async ({ idToken, email, name, picture, uid }) => {
    const response = await authApi.post('/social-login', {
      idToken,
      email,
      name,
      picture,
      uid
    })
    return response.data
  },

}